<div class="container-corte">
  <div [style.width]="larguraExibir() + 'px'"  >
    <div class="form-group mb-12">
      <label for="foto">{{label}}     <i class="fa fa-edit fa-lg"  *ngIf="getLinkImagem()" (click)="editarImagem=!editarImagem" ></i>
      </label>
      <div *ngIf="!exibirSelecionarImagem()">
        <img id="foto" src="/images/empresa/{{getLinkImagem()}}"  [style.width]="config.minWidth + 'px'" >
      </div>

      <div *ngIf="exibirSelecionarImagem()">
        <div class="area-corte"
             [style.width]="larguraExibir() + 'px'"
             [style.max-width]="'100%'"
             [style.aspect-ratio]="config.ratio"
             [ngClass]="{'largo': larguraExibir() > 300, 'medio': larguraExibir() >= 200}"
             *ngIf="!imageChangedEvent">

          <div class="k-dropzone">
            <div class="upload-container">
              <i class="fa fa-cloud-upload-alt fa-3x mb-3 d-block"></i>

              <div class="k-button k-upload-button" aria-label="Selecione..." role='button'>
                <input type="file"
                       (change)="fileChangeEvent($event)"
                       name="file"
                       accept="image/*" />
                <span>Selecione uma foto</span>
              </div>
              <p class="upload-info mt-2">
                <small>Formatos aceitos: JPG, PNG, GIF</small>
              </p>
            </div>
          </div>
        </div>

        <p class="text-danger" *ngIf="erroLoadImage">
          <b>{{erroLoadImage}}</b>
        </p>

        <div *ngIf="imageChangedEvent " [hidden]="salvar">
          <image-cropper #imageCropper
                         [imageFile]="imageCropData"
                         [imageChangedEvent]="imageChangedEvent"
                         [maintainAspectRatio]="true"
                         [aspectRatio]="config.ratio"
                         [resizeToWidth]="config.resizeWidth"
                         [cropperMinWidth]="config.minWidth"
                         [onlyScaleDown]="true"
                         [roundCropper]="false"
                         format="png"
                         outputType="base64"
                         (imageCropped)="imageCropped($event)"
                         (imageLoaded)="imageLoaded()"
                         (cropperReady)="cropperReady()"
                         (loadImageFailed)="loadImageFailed()"
                         [style.display]="showCropper ? null : 'none'"
                         [alignImage]="'left'"
          ></image-cropper>

          <div class="  mt-2 botoes" >
            <button class="btn btn-success  mr-1" (click)="corteImagem()" [disabled]="cortando" > Cortar</button>
            <button class="btn btn-secondary" (click)="canceleImagem()" [disabled]="cortando"> Cancelar</button>
          </div>

          <p *ngIf="erro" class="text-danger mt-2"><b>{{erro}}</b></p>

        </div>

      </div>
    </div>

    <div *ngIf="salvar" class="mt-2">
      <p>Imagem está correta, podemos salvar? </p>
      <div class="botoes">
        <button class="btn btn-primary mr-1" (click)="salve()" [disabled]="salvando"> <i class="fa fa-save fa-lg fa-fw"></i> Salvar</button>
        <button class="btn btn-outline-secondary" (click)="canceleSalvar()"> <i class="fa fa-times fa-lg fa-fw"></i> Cancelar</button>
      </div>

      <p *ngIf="erro" class="text-danger mt-2"><b>{{erro}}</b></p>

    </div>

  </div>
</div>









